import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import JobService from "services/jobAd";
import CategoryView from "./view";

class Category extends Component {
  state = {
    jobs: [],
    page: 0,
    loaded: false,
  };

  componentDidMount() {
    let categoryID;
    const { match } = this.props;

    if (match) categoryID = match.params.id;
    this.getJobsByCategory(categoryID);
  }

  componentDidUpdate(prevProps, prevState) {
    let categoryID;

    if (this.props.match && this.props.match !== prevProps.match) {
      this.setState({ jobs: [], loaded: false, page: 0 }, () => {
        categoryID = this.props.match.params.id;
        this.getJobsByCategory(categoryID);
      });
    }
  }

  getJobsByCategory = (category) => {
    JobService.getJobsByCategory(category, this.state.page).then((res) => {
      if (res)
        this.setState({ jobs: this.state.jobs.concat(res), loaded: true });
    });
  };

  paginate = () => {
    const categoryID = this.props.match.params.id;

    this.setState({ page: this.state.page + 1 }, () => {
      this.getJobsByCategory(categoryID);
    });
  };

  render() {
    const { jobs, loaded } = this.state;
    const { match } = this.props;
    let categoryID;

    if (match) categoryID = match.params.id;

    return (
      <CategoryView
        jobs={jobs}
        category={categoryID}
        paginate={this.paginate}
        loaded={loaded}
      />
    );
  }
}

export default withRouter(Category);
